import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";
import { AppContext } from "../../context/AppContext";
import { CartContext } from "../../context/CartContext";
const StyledCard = styled(Card)({
  borderRadius: "1rem",
  boxShadow: "none",
  position: "relative",
  minWidth: 200,
  minHeight: 360,
  "&:after": {
    content: '""',
    display: "block",
    position: "absolute",
    width: "100%",
    height: "64%",
    bottom: 0,
    zIndex: 1,
    background: "linear-gradient(to top, #000, rgba(0,0,0,0))",
  },
});

const StyledCardMedia = styled(CardMedia)({
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  right: 0,
  zIndex: 0,
  backgroundPosition: "top",
});

const Content = styled("div")(({ theme }) => ({
  padding: theme.spacing(3, 2),
  position: "absolute",
  zIndex: 2,
  top: 0,
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    textAlign: "center",
  },
}));

const Title = styled("h1")(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  borderRadius: "1rem",
  fontSize: "3rem",
  letterSpacing: "1px",
  fontWeight: "bold",
  textTransform: "initial",
  marginBottom: 0,
  padding: theme.spacing(0, 2),
  [theme.breakpoints.down("sm")]: {
    fontSize: "2rem",
  },
}));

const Subtitle = styled("h2")(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  borderRadius: "1rem",
  fontSize: "1.5rem",
  fontWeight: "bold",
  lineHeight: 1.2,
  padding: theme.spacing(0, 2),
  [theme.breakpoints.down("sm")]: {
    fontSize: ".85rem",
  },
}));

const ButtonArea = styled("div")(({ theme }) => ({
  padding: theme.spacing(3, 2),
  position: "absolute",
  zIndex: 3,
  bottom: 0,
  width: "100%",
  textAlign: "right",
  [theme.breakpoints.down("sm")]: {
    textAlign: "center",
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  color: "#fff",
  borderRadius: "1rem",
  border: "1px solid #fff",
  padding: theme.spacing(1, 2),
  backgroundColor: theme.palette.common.fadeToBlack,
  fontSize: "1.75rem",
  lineHeight: 1.2,
  transition: "all 0.5s ease",
  "&:hover": {
    fontSize: "2rem",
    fontWeight: "bold",
  },
}));

// todo: pull this from club config
const heroImage =
  "https://firebasestorage.googleapis.com/v0/b/manageyourclub-973b2.appspot.com/o/clubs%2Fdemo%2Fheader%2Fchess-club-header.jpg?alt=media&token=c2a4454f-a2cc-471a-8854-c577b8a87bf4";
// const heroImage =
//   "https://firebasestorage.googleapis.com/v0/b/manageyourclub-973b2.appspot.com/o/clubs%2Fcola-stl%2Fheader%2Fheader-your-spot.jpg?alt=media&token=59c86b8e-e6a1-47cd-ab9e-bd051dc6de29";

export function DefaultHeader() {
  const { passTemplates } = useContext(AppContext);
  const { addToCart } = useContext(CartContext);
  const navigate = useNavigate();

  const dayPass = passTemplates.find((pass) => pass.type === "day");

  const addPassAndCheckout = () => {
    addToCart(dayPass);
    navigate("/checkout");
  };

  return (
    <StyledCard>
      <StyledCardMedia image={heroImage} />
      <Content>
        <Title>Find Your Spot</Title>
        <Subtitle>Where Buds Meet</Subtitle>
      </Content>
      <ButtonArea>
        <StyledButton onClick={addPassAndCheckout}>Get A Day Pass</StyledButton>
      </ButtonArea>
    </StyledCard>
  );
}
